module.exports = __webpack_public_path__ + "img/EmptyFolder.8c5504f3.svg";